var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCta2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 775,
    height: 717,
    viewBox: "0 0 775 717",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_460_32946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M775 86L100 717H775V86Z",
    fill: "url(#paint0_linear_460_32946)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_460_32946",
    x: 0,
    y: -14,
    width: 875,
    height: 831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_460_32946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_32946",
    x1: 437.5,
    y1: 86,
    x2: 437.5,
    y2: 717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D90A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA83C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCta2);
export default __webpack_public_path__ + "static/media/cta-2.b7b68c3a37fc1668ace3d48bfcdafa03.svg";
export { ForwardRef as ReactComponent };